<ion-content>
	<div class="banner-container">
		<img class="header-banner-tmp" alt="" src="../../../assets/icons/tmp-banners/dancebug-something-went-wrong-banner.svg" />
	</div>
	<app-loading class="frame-stack-110000" [loading]="(loadingWithSpinner$ | async) ?? false"></app-loading>
	<div class="d-flex flex-col ion-align-items-center ion-justify-content-center ion-padding ion-text-center mt-55">
		<div class="my-55"></div>
		<ion-text class="ion-margin-bottom" color="primary">
			<strong> {{ lang$ | async | langTag : 'This version of the app is no longer supported.' }} </strong>
		</ion-text>
		<ion-text class="ion-margin-bottom" color="primary">
			{{ lang$ | async | langTag : 'Please update now to continue using the app.' }}
		</ion-text>
		<ion-button class="ion-margin w-100" shape="round" expand="block" [href]="storeLink()" target="_blank">
			<strong> {{ lang$ | async | langTag : storeText : 'uppercase' }} </strong>
		</ion-button>
	</div>
</ion-content>
